export enum Env {
  Dev = "DEV",
  Staging = "STAGING",
  Prod = "PROD",
}

export const LOGOUT_TIME = 3600;
export const DOCUMENT_TITLE = "Claims Texting";
export const CUSTOMER = "customer";
export const ADJUSTER = "adjuster";
export const SEND = "send";
export const RECEIVED = "received";
export const NEW = "new";
export const CONVERSATION = "Conversation";
export const JPEG = "jpeg";
export const IMAGE = "img";
export const REMOVE_FROM_CHAT = "Remove From Chat";
export const REJOIN_CHAT = "Rejoin Chat";
export const ACTIVE = "active";
export const INACTIVE = "inactive";
export const ERROR = "Error";
export const SUCCESS = "Success";
export const ADVANCED_SEARCH = "Advanced Search";
export const SIMPLE_SEARCH = "Simple Search";
export const SCHEDULE_TIME_ERROR = "Start Time should be before End Time";
export const PROFILE_UPDATED_SUCCESS = "Information Updated Successfully";
export const EXPORT_LOCATION = "Select Export Location";
export const NO_CONVERSATION_ERROR =
  "There is no Conversation associated with the Requested Claim.";
export const SESSION_ERROR =
  "Cannot retrieve a new session. Please authenticate.";
export const NO_CURRENT_USER = "No current user";
export const REMOVED_ADJUSTER = "Removed From Chat Successfully";
export const REJOINED_ADJUSTER = "Rejoined To The Chat Successfully";
export const JOINED_ADJUSTER = "Successfully Added To The Chat ";
export const STATE_AUTO_INSURANCE = "State Auto Insurance";
export const OPT_OUT_MESSAGE =
  "Reply Stop to end texting. Visit https://www.stateauto.com/text for terms and conditions. Msg&data rates may apply.";
export const VIEW_CONVERSATIONS = "VIEW CONVERSATIONS";
export const NEW_SEARCH = "NEW SEARCH";
export const REMOVE = "Remove";
export const REMOVE_ALL = "Remove All";
export const TRANSFER = "Transfer";
export const COVER = "Cover";
export const COPY = "Copy";
export const TRANSFER_ALL = "Transfer All";
export const COPY_ALL = "Copy All";
export const COVER_ALL = "Cover All";
export const CANCEL = "Cancel";
export const SELECT_ALL = "Select All";
export const NO_ACTION = "No Action";
export const SEARCH = "Search";
export const MY_INFORMATION = "My Information";
export const MY_OUTOFOFFICE = "My Out of Office";
export const USER_PROFILE = "User Profile";
export const LOGOUT = "Log Out";
export const CONTACT_SEARCH = "Contact Search";
export const ACTIVE_CONVERSATIONS = "Active Conversations";
export const CONVERSATION_CONTROL = "Conversation Control";
export const CONVERSATION_VIEWER = "Conversation Viewer";
export const ARCHIVED_CONVERSATIONS = "Archived Conversations";
export const PLUS = "+";
export const STOP = "STOP";
export const TEXTING_ACCESS = "Texting Access";
export const CONFIRM_MESSAGE ="Are you sure want to clear Out of Office Status?";
export const CLEAR_MESSAGE ="Cleared Out of Office Status.";
export const DATE_ERROR = "Start Date can not be after the End Date";
export const TURNOFF_LABEL ="Turning off Out of Office will clear your current status";
export const OOO_TITLE = "Current Out of Office Status";
export const STARTDATE_ERROR ="Please enter start date";
export const ENDDATE_ERROR ="Please enter end date";
export const OOO_MESSAGEERROR ="Please enter Out of Office message";

export const OPT_OUT_MESSAGES = [
  "STOP",
  "STOPALL",
  "UNSUBSCRIBE",
  "CANCEL",
  "END",
  "QUIT",
];
export const OPT_IN_MESSAGES = ["START", "YES", "UNSTOP"];

export const SNACKBAR = {
  ERROR: "snackbar-error",
  SUCCESS: "snackbar-success",
};

export const CONVERSATION_CONTROL_TABS = {
  MYCONVERSATIONS: "My Conversations",
  ALLCONVERSATIONS: "All Conversations",
};
export const USER_PREFERENCES_TABS = {
  MY_INFORMATION: "My Information",
  MY_PREFERENCES: "My Preferences",
  MY_OUTOFOFFICE: "My Out of Office"
};
export const CC_PARAMS = {
  CLAIM_NUMBER: "claimNumber",
  ADJUSTER_ID: "adjusterId",
  PHONE_NUMBER: "phoneNumber",
  CONTACT_ID: "contactId",
  CUSTOMER_NAME: "customerName",
};

export const CC_PARAMS_REGEX: any = {
  claimNumber: "[A-Z]{2}-[0]{7}-\\d{6}",
  customerName: "[A-Za-z0-9 ]+",
  contactId: "[A-Za-z0-9 ]:\\w",
  phoneNumber: "\\d{10}",
  adjusterId: ".+@stateauto.com",
  textNumber: "\\d{10}",
  env: "[\\w]+",
  firstName: "[A-Za-z0-9 ]",
  lastName: "[A-Za-z0-9 ]",
  uwCompany: "[A-Za-z0-9 ]+"
};
export const NOTIFICATION_SOUNDS: any = {
  sounds: [
    { label: "alert_simple", value: "alert_simple" },
    { label: "ambient", value: "ambient" },
    { label: "decorative-01", value: "decorative-01" },
    { label: "decorative-02", value: "decorative-02" },
    { label: "default", value: "default" },
    { label: "high-intensity", value: "high-intensity" },
    { label: "simple-01", value: "simple-01" },
    { label: "simple-02", value: "simple-02" },
  ],
};
export const sampleConversations = [
  {
    time: "December 21, 2021 - 8:30am EST - Stanley Johns",
    insuredName: "Jonathan Hicks",
    claim: "AU- 2264553-8937485",
    productType: "Auto",
    status: "Open",
  },
  {
    time: "December 21, 2021 - 8:30am EST - Stanley Johns",
    insuredName: "Jonathan Hicks",
    claim: "AU- 2264553-8937485",
    productType: "Auto",
    status: "Open",
  },
  {
    time: "December 21, 2021 - 8:30am EST - Stanley Johns",
    insuredName: "Jonathan Hicks",
    claim: "AU- 2264553-8937485",
    productType: "Auto",
    status: "Open",
  },
  {
    time: "December 21, 2021 - 8:30am EST - Stanley Johns",
    insuredName: "Jonathan Hicks",
    claim: "AU- 2264553-8937485",
    productType: "Auto",
    status: "Open",
  },
  {
    time: "December 21, 2021 - 8:30am EST - Stanley Johns",
    insuredName: "Jonathan Hicks",
    claim: "AU- 2264553-8937485",
    productType: "Auto",
    status: "Open",
  },
  {
    time: "December 21, 2021 - 8:30am EST - Stanley Johns",
    insuredName: "Jonathan Hicks",
    claim: "AU- 2264553-8937485",
    productType: "Auto",
    status: "Open",
  },
  {
    time: "December 21, 2021 - 8:30am EST - Stanley Johns",
    insuredName: "Jonathan Hicks",
    claim: "AU- 2264553-8937485",
    productType: "Auto",
    status: "Open",
  },
  {
    time: "December 21, 2021 - 8:30am EST - Stanley Johns",
    insuredName: "Jonathan Hicks",
    claim: "AU- 2264553-8937485",
    productType: "Auto",
    status: "Open",
  },
  {
    time: "December 21, 2021 - 8:30am EST - Stanley Johns",
    insuredName: "Jonathan Hicks",
    claim: "AU- 2264553-8937485",
    productType: "Auto",
    status: "Open",
  },
  {
    time: "December 21, 2021 - 8:30am EST - Stanley Johns",
    insuredName: "Jonathan Hicks",
    claim: "AU- 2264553-8937485",
    productType: "Auto",
    status: "Open",
  },
];

export const testConversations = [
  {
    conversationStatus: "active",
    participants: [
      {
        name: "Martin" + " " + "Clowe",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-123356",
    conversationId: "dszsc",
  },
  {
    conversationStatus: "active",
    participants: [
      {
        name: "Matt" + " " + "Clark",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-123356",
    conversationId: "SAdasd",
  },
  {
    conversationStatus: "active",
    participants: [
      {
        name: "Rod" + " " + "Tucker",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-423456",
    conversationId: "WDasd",
  },
  {
    conversationStatus: "active",
    participants: [
      {
        name: "L" + " " + "Jennifer",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-123454",
    conversationId: "34",
  },
  {
    conversationStatus: "active",
    participants: [
      {
        name: "Daniel" + " " + "Sams",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-122456",
    conversationId: "456",
  },
  {
    conversationStatus: "active",
    participants: [
      {
        name: "Mark" + " " + "Wade",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-129456",
    conversationId: "wa",
  },
  {
    conversationStatus: "active",
    participants: [
      {
        name: "Shane" + " " + "Watson",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-123556",
    conversationId: "213",
  },
  {
    conversationStatus: "active",
    participants: [
      {
        name: "G" + " " + "Pattrick",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-123156",
    conversationId: "ewsafd",
  },
  {
    conversationStatus: "active",
    participants: [
      {
        name: "Mark" + " " + "Cornut",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-123426",
    conversationId: "dsad",
  },
  {
    conversationStatus: "active",
    participants: [
      {
        name: "Luke" + " " + "Tester",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-123486",
    conversationId: "asdasd",
  },
  {
    conversationStatus: "active",
    participants: [
      {
        name: "Thomas" + " " + "Wade",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-123476",
    conversationId: "wasdsa",
  },
  {
    conversationStatus: "active",
    participants: [
      {
        name: "John" + " " + "Smith",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-123426",
    conversationId: "wasdas",
  },
  {
    conversationStatus: "active",
    participants: [
      {
        name: "Mark" + " " + "Taylor",
        phoneNumber: "+1330-822-8624",
        participantType: "customer",
      },
    ],
    adjusterId: "test@sa.com",
    claimNumber: "GWCC-123416",
    conversationId: "sadasd",
  },
];
